const API_BASE = '/api/';

/* Login */
export const AUTH = API_BASE + 'auth';
export const LOGOUT = API_BASE + 'logout';

/* IdP */
export function GET_IDP_METADATA() {
  return API_BASE + `idpMetadata`;
}

export function GET_IDP_CERTIFICATE() {
  return API_BASE + `idpMetadataCertificate`;
}

/* SBA / Service Provider metadata */
export const SP = API_BASE + 'app';

export function ADD_SP() {
  return `${SP}`;
}

export function GET_APP_LIST() {
  return `${SP}`;
}

export function GET_APP(appId) {
  return `${SP}/${appId}`;
}

export function DELETE_APPS() {
  return `${SP}`;
}

export function DELETE_APP(appId) {
  return `${SP}/${appId}`;
}

export function UPDATE_APP(appId) {
  return `${SP}/${appId}`;
}

/* Parse XML data */
export function PARSE_FROM_URL() {
  return API_BASE + `parseFromUrl`;
}

export function PARSE_FROM_XML() {
  return API_BASE + `parseMetadataXML`;
}

/* Customization*/
export function SAVE_CUSTOMIZATION() {
  return API_BASE + 'customize';
}

export function GET_CUSTOMIZATION() {
  return API_BASE + 'customize';
}

/* Azure AD */
export function AZURE_AD() {
  return API_BASE + 'azureAdTenant';
}

export function DELETE_AZURE_AD(id) {
  return API_BASE + 'azureAdTenant/' + id;
}

export function GET_AZURE_AD_LIST() {
  return API_BASE + 'azureAdTenant';
}

export function GET_AZURE_AD_JSON() {
  return API_BASE + 'azureCustomControl';
}


// WEBPACK FOOTER //
// ./src/constants/apiEndpoints.js